import styled, { css } from "styled-components";

const active = css`
  background-color: #2196f3;
  color: #fff;
`;
export const Container = styled.div``;

export const Div = styled.div`
  padding: 40px 0 0 0;
`;

export const Body = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 5%;
  margin-right: 10%;
  overflow: auto;
  padding-bottom: 10%;
  @media (max-width: 1024px) {
    margin-right: 5%;
    height: 80%;
    padding-bottom: 25%;
  }
`;
export const DivTitle = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5%;
  margin-top: 20px;
`;
export const DivPatient = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: white;
  padding: 10px;
  @media (max-width: 1024px) {
    flex-direction: row;
    align-items: center;
  }
`;
export const DivBody = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  background-color: white;
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const TitleSchedule = styled.h4`
  width: 250px;
  font-weight: bold;
  font-size: 16px;
  margin: 0 0 5px;
`;

export const SubTitleSchedule = styled.p`
  width: 100%;
  font-size: 14px;
  color: #909090;
`;
export const SubTitleInfo = styled.div`
  display: flex;
  font-weight: bold;
  font-size: 16px;
  color: #707070;
`;
export const TitleInfo = styled.div`
  display: flex;
  font-size: 12px;
  margin-top: 15px;
  color: #b3b3b3;
  @media (max-width: 1024px) {
    margin-top: 0;
    margin-right: 10px;
  }
`;
export const DivScheduled = styled.div`
  display: flex;
  width: 80%;
  height: 100%;
  flex-direction: row;
  margin-left: 26px;

  @media (max-width: 1024px) {
    width: 100%;
    height: 100%;
    flex-direction: column;
    margin: 0;
  }
`;
export const DivBoxScheduledIcons = styled.div`
  display: flex;
  width: 168px;
  height: 84px;
  flex-direction: column;
  background-color: #f1f1f1;
`;
export const DivHeader = styled.div`
  display: flex;
  border-radius: 4px;
  width: 60%;
  flex-direction: row;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;
export const BoxDateTime = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  flex-direction: column;
  color: white;
  margin-right: 1px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #2196f3;
  @media (max-width: 1024px) {
    height: 83px;
  }
`;

export const TitleDate = styled.div`
  font-size: 16px;
`;

export const TitleTime = styled.div`
  font-size: 12px;
  margin-left: 10px;
`;

export const DivBoxScheduledInfo = styled.div`
  display: flex;
  flex-direction: row;
  border: 60px;
  border-color: red;
  justify-content: flex-start;
  width: 100%;
  height: 84px;
  background-color: white;
`;
export const BoxTextScheduled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 83px;
  height: 87px;
  flex-direction: column;
  color: white;
  margin-right: 1px;
`;
export const DivButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 25%;
  align-items: center;
  background-color: white;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  @media (max-width: 1024px) {
    width: 100%;
    height: 100%;
    background-color: white;
    margin: 0;
  }
`;
export const Button = styled.button`
  width: 83px;
  height: 30px;
  border-radius: 5px;
  color: #fff;
  margin: 0 5px;

  ${(props) => props.blue && blue}
  ${(props) => props.gray && gray}

  @media (max-width: 1024px) {
    margin: 10px;
    width: 60%;
    height: 30px;
  }
`;

const blue = css`
  background-color: #2196f3;
`;

const gray = css`
  background-color: #d1d1d1;
`;

export const HeaderScheduled = styled.div`
  display: flex;
  width: 100%;
  height: 80%;
  flex-direction: column;
  margin-top: 15px;
`;

export const NoSchedules = styled.div`
  width: 70%;
  height: 160px;
  background: transparent;
  display: flex;
  border: 1px dashed #707070;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  color: #909090;

  @media (max-width: 1024px) {
    width: 100%;
    margin-top: 25px;
  }
`;
export const NewSchedule = styled.div`
  width: 70%;
  height: 55px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #2196F3;
  border-radius: 4px;
  margin-top: 30px;
  color: #ffffff;
  cursor: pointer;
  @media (max-width: 1024px) {
    width: 100%;
    margin-top: 0px;
    display: ${(props) => props.hideMobile ? 'none' : 'flex'};
  }
`;

export const NewScheduleDiv = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  margin-left: 5%;
  margin-right: 10%;
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const NewScheduleButton = styled.button`
  height: 66px;
  width: 139px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-weight: 600;
  background-color: #2196F3;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
`;

export const IconText = styled.button`
  font-size: 20px;
  color: #fff;
  margin-bottom: 5px;
`;

export const NewScheduleMobile = styled.div`
  display: none;
  @media (max-width: 1024px) {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    position: fixed;
    background-color: red;
    height: 55px;
    bottom: 0;
    // padding: 0 5% 0 5%;
    background-image: linear-gradient(to bottom, rgba(241, 241, 241, 0.5), rgba(241, 241, 241, 1));
  }  

`;